import { TStockAdjustment } from "@helpers/validation-schemas/warehouse-and-inventory/stock-adjustment.schema";
import { TStockImport } from "@helpers/validation-schemas/warehouse-and-inventory/stock-import.schema";
import { useGetAllStockAdjustmentsQuery } from "@states/warehouse-and-inventory/stock-adjustment.api";
import { useGetAllStockImportsQuery } from "@states/warehouse-and-inventory/stock-import.api";
import { TSuccessResponse } from "@type-defs/general/TSuccessResponse";

const useGetAllStockAdjustments = (args: {
  page?: number;
  limit?: number;
  search?: string;
  from_date?: string;
  to_date?: string;
}) => {
  const {
    data: rawData,
    error,
    isLoading,
    refetch,
    isFetching,
  } = useGetAllStockAdjustmentsQuery({ ...args });

  const stockAdjustmentResponse =
    rawData as any as TSuccessResponse<TStockAdjustment>;

  return {
    stockAdjustmentData: stockAdjustmentResponse?.data,
    stockAdjustmentMessage: stockAdjustmentResponse?.message,
    stockAdjustmentSuccess: stockAdjustmentResponse?.success,
    stockAdjustmentPaginator: stockAdjustmentResponse?.paginator,
    stockAdjustmentError: error,
    stockAdjustmentLoading: isLoading,
    stockAdjustmentRefetch: refetch,
    stockAdjustmentFetching: isFetching,
  };
};

export default useGetAllStockAdjustments;
